import * as React from "react";
import styled from "styled-components/native";

import { Clazz } from "../types";
import AppContext from "../app-context/AppContext";
import Layout from "../components/common/Layout";
import List from "../components/common/List";
import Text from "../components/common/Text";
import useListClazzes from "../hooks/clazzes/useListClazzes";
import User from "../components/user";
import { Divider, Info, JustifyContent, Space } from "../styled-component";
import Button from "../components/common/PressableButton";
import Card from "../components/common/Card";
import { ScrollView } from "react-native";
import CreateClazz from "./CreateClazz";
import JoinClass from "./JoinClazz";
import CreateOrUpdateClazz from "../components/clazz/CreateOrUpdateClazz";

export interface ClazzesListCardProps {
  onPress?: (clazz: Clazz) => void;
  greedy?: boolean;
  isClazzSelected?: (clazz: Clazz) => boolean;
}

function ClazzesListCard({
  onPress,
  greedy,
  isClazzSelected,
}: ClazzesListCardProps) {
  const query = useListClazzes();

  return (
    <Card
      greedy={greedy}
      header={
        <Card.Header
          title="Classes"
          label={`Number of Classes: ${(query.data || []).length}`}
        />
      }
    >
      <Card.SubHeader
        right={
          <Layout.Box size={1}>
            <AppContext.Instructor>
              <CreateOrUpdateClazz />
            </AppContext.Instructor>

            <AppContext.Learner>
              <JoinClass />
            </AppContext.Learner>
          </Layout.Box>
        }
      />

      <Layout.Column greedy>
        <ScrollView>
          <Space />

          <List.Async<Clazz>
            {...query}
            renderEmpty={() => (
              <Layout.Box fullWidth alignItems="center">
                <AppContext.Instructor>
                  <Text>Press 'Create Class' to add a class</Text>
                </AppContext.Instructor>

                <AppContext.Learner>
                  <Text>Press 'Join Class' to add a class</Text>
                </AppContext.Learner>
              </Layout.Box>
            )}
            renderItem={({ item, index }: { item: Clazz; index: number }) => (
              <>
                <Button
                  onPress={() => onPress?.(item)}
                  selected={isClazzSelected?.(item)}
                  roundness={0}
                >
                  <List.Item
                    title={<Text.SubHeader>{item.name}</Text.SubHeader>}
                    description={
                      <>
                        <AppContext.Instructor>
                          <Layout.Row alignItems="baseline">
                            <Text.Label>Code: {item.code}</Text.Label>
                          </Layout.Row>
                        </AppContext.Instructor>

                        <AppContext.Learner>
                          <Layout.Row alignItems="baseline">
                            <Text.Label>
                              Instructor:{" "}
                              <User.DisplayName user={item.instructor} />
                            </Text.Label>
                          </Layout.Row>
                        </AppContext.Learner>
                      </>
                    }
                  />
                </Button>

                {query.data && index < query.data.length - 1 && <Divider />}
              </>
            )}
          />

          <Space />
        </ScrollView>
      </Layout.Column>
    </Card>
  );
}

export default ClazzesListCard;
